function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-1926.7 -3097.8 12 9"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#262727",
  d: "M-1926.7-3096.8v-1h12v1zm0 4v-1h12v1zm0 4v-1h12v1z"
})));